import Auth from "./API/Auth";
import OptionsAPI from "./API/OptionsAPI";
import FormAPI from "@/services/API/FormAPI";
import UploadImageAPI from "@/services/API/UploadImageAPI";
import CommunityAPI from "@/services/API/CommunityAPI";
import ViewAPI from "@/services/API/ViewAPI";
import CategoriesAPI from "@/services/API/CategoriesAPI";
import KnowledgesAPI from "@/services/API/KnowledgesAPI";

export default {
  Auth,
  OptionsAPI,
  FormAPI,
  UploadImageAPI,
  CommunityAPI,
  ViewAPI,
  CategoriesAPI,
  KnowledgesAPI
};
